import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { environment } from '../environments/environment';

import { LocatorService } from './locator.service';

import { AuthService } from 'auth-monitorias-uniandes';
import { LoginModel } from './login/login.model';
import { UserModel } from './shared/models/user.model';

@Injectable()
export class LoginService {

  constructor(
    private http          : HttpClient,
    private locatorService: LocatorService,
    private authService   : AuthService
  ) { }

  doLogin(userLogin: LoginModel) {
    if (environment.federatedAuth) {
      return this.authService.doSamlLogin(null);
    } else {
      userLogin.usr = userLogin.usr.toLowerCase();
      return this.authService.doLogin(userLogin);
    }
  }

  doLogout() {
    if (environment.federatedAuth) {
      return this.authService.doSamlLogout();
    } else {
      return this.authService.doLogout();
    }
  }

  getCurrentUser(key?: string) {
    return this.authService.getCurrentUser();
  }

  getCurrentUserPerson(key?: string) {
    const user$ = this.authService.getCurrentUser();
    return user$.pipe(
      mergeMap((user: UserModel) => {
        return forkJoin(
          of(user),
          this.getSearchPerson(user.userName),
        );
      })
    )
  }

  getSearchPerson(username: string) {
    return this.authService.searchPersons(username);
  }

  public getPhoto(username: string): Observable<Blob> {
    return this.http.get(this.locatorService.getPhoto(username), { responseType: 'blob' })
  }

}



// WEBPACK FOOTER //
// ./src/app/login.service.ts